"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllItemsAvailabilitiesExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const deserializer_1 = tslib_1.__importDefault(require("../../../utils/deserializer"));
const getFromRelationship_1 = tslib_1.__importDefault(require("../../../utils/deserializer/getFromRelationship"));
const service_1 = tslib_1.__importDefault(require("./service"));
const getAllItemsAvailabilities = toolkitRaw.createAsyncThunk('marketplace/fetch_all_items_availabilities', async ({ params }, { rejectWithValue }) => {
    try {
        const response = await (0, service_1.default)(params);
        const responseData = (0, getFromRelationship_1.default)(response, 'item', 'item_id');
        const deserialized = (0, deserializer_1.default)(responseData);
        return deserialized.data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getAllItemsAvailabilitiesExtraReducers = (builder) => {
    builder.addCase(getAllItemsAvailabilities.pending, (state) => {
        state.slices.availability.loading = true;
    });
    builder.addCase(getAllItemsAvailabilities.fulfilled, (state, action) => {
        state.slices.availability.loading = false;
        state.slices.availability.error = false;
        state.slices.availability.data = action.payload;
    });
    builder.addCase(getAllItemsAvailabilities.rejected, (state) => {
        state.slices.availability.loading = false;
        state.slices.availability.error = true;
    });
};
exports.getAllItemsAvailabilitiesExtraReducers = getAllItemsAvailabilitiesExtraReducers;
exports.default = getAllItemsAvailabilities;
//# sourceMappingURL=index.js.map